module.exports = __webpack_public_path__ + "img/banner-comercio.fd88bfb5.png";